export const numberTagInputs = ['Age', '# of products', 'Study sample size']
